import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingPage from '../pages/LoadingPage';
import { useExpert } from '../redux/slices/expert/useExpert';
import { useBusiness } from '../redux/slices/business/useBusiness';

interface RequiresExpertRouteProps {
  children: React.ReactNode;
}

const RequiresExpertRoute: React.FC<RequiresExpertRouteProps> = ({ children }) => {
  const { updating: updatingExpert, body } = useExpert();
  const { updating: updatingBusiness} = useBusiness();
  const location = useLocation();
  let title = 'Updating'

  if (updatingExpert || updatingBusiness) {
    return <LoadingPage title={title}/>
  }

  if (!body && location.pathname !== '/expert/billing') {
    return <Navigate to="/expert/billing" state={{ from: location }} replace />
  }

  return <>{children}</>;
};

export default RequiresExpertRoute;
